<template>
  <div
    v-if="
      auth.user.selectedAccess.roleLevel > 0 ||
        (store && auth.user.selectedAccess.store_id == store.id)
    "
  >
    <loading-spinner v-if="!store" />
    <app-header
      v-if="store"
      :title="store.name"
      :subtitle="`${getLabel('STORE')} #${store.id}`"
    >
      <template #col-right>
        <div v-if="auth.user.selectedAccess.can_modify_settings">
          <b-button
            v-router-link="{ name: 'store-editor', query: { id: store.id } }"
            variant="primary"
            size="lg"
          >
            <i
              class="fa fa-pencil-square-o"
              style="font-size:20px"
            />&nbsp;<span v-label-key="'EDIT_STORE'">Edit Store</span>
          </b-button>
        </div>
      </template>
    </app-header>

    <b-container>
      <b-nav tabs fill class="mb-3">
        <b-nav-item :to="{ name: 'store-reports-tab' }">
          <span v-label-key="'REPORTS'">Reports</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'store-transactions-tab' }">
          <span v-label-key="'TRANSACTIONS'">Transactions</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel >= 3"
          :to="{ name: 'store-installs-tab' }"
        >
          <span v-label-key="'INSTALLS'">Installs</span> ({{
            summary?.installCount || 0
          }})
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.roleLevel > 2"
          :to="{ name: 'store-users-tab' }"
        >
          <span v-label-key="'USERS'">Users</span> ({{
            summary?.userCount || 0
          }})
        </b-nav-item>
        <b-nav-item :to="{ name: 'store-location-tab' }">
          <span v-label-key="'LOCATION'">Location</span>
        </b-nav-item>
        <b-nav-item :to="{ name: 'store-about-tab' }">
          <span v-label-key="'ABOUT'">About</span>
        </b-nav-item>
        <b-nav-item
          v-if="auth.user.selectedAccess.can_manage_staff"
          :to="{ name: 'store-staff-tab' }"
        >
          <span v-label-key="'STAFF'">Staff</span> ({{ summary?.retailStaffCount || 0 }})
        </b-nav-item>
      </b-nav>
      <div>
        <router-view
            :store_id="$route.params.id"
          />
      </div>
    </b-container>
  </div>
</template>
<script>
import $auth from '@/services/auth';
import $api from '@/services/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import AppHeader from '@/components/AppHeader';
import { mapGetters } from 'vuex';

export default {
  components: {
    LoadingSpinner,
    AppHeader,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  data() {
    return {
      auth: $auth,
      store: null,
      summary: null,
    };
  },
  created() {
    this.refreshData();
  },
  methods: {
    refreshData() {
      this.$store.commit('global/clearAllState');

      $api.get(`/v1/dashboard/stores/${this.$route.params.id}`).then(store => {
        this.store = store;
      });

      $api.get(`/v1/dashboard/stores/summary?store_id=${this.$route.params.id}`).then(summary => {
        this.summary = summary;
      });

      // this.$store.dispatch('global/getInstalls', {
      //   store_id: this.$route.params.id,
      // });
      // this.$store.dispatch('global/getUsers', {
      //   store_id: this.$route.params.id,
      // });
    },
  },
};
</script>

<style scoped>
a {
  color: black;
}
</style>
